import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/services";

const ServiceCard = ({ svc, className = "" }) => {
  const Icon = svc.icon;
  return (
    <Link
      to={`/services#${svc.id}`}
      data-testid={svc.testId}
      className={`group relative bg-[#0B132B]/50 border border-white/10 p-8 md:p-10 hover-lift flex flex-col justify-between overflow-hidden ${className}`}
    >
      <div>
        <div className="flex items-start justify-between">
          <span className="font-mono text-[11px] text-red-500 tracking-widest">
            /{svc.code}
          </span>
          <ArrowUpRight
            size={18}
            className="text-slate-500 group-hover:text-red-500 transition-colors"
          />
        </div>

        <div className="mt-8 flex items-center gap-3">
          <Icon size={20} className="text-red-500" strokeWidth={1.5} />
          <h3 className="font-display text-white text-xl md:text-2xl tracking-tight leading-tight">
            {svc.title}
          </h3>
        </div>

        <p className="mt-5 text-slate-400 text-sm md:text-[15px] leading-relaxed max-w-xl">
          {svc.short}
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between">
        <span className="font-mono text-[10px] text-slate-500 tracking-[0.22em] uppercase">
          Practice · Sriman
        </span>
        <span className="text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
          Read more →
        </span>
      </div>
    </Link>
  );
};

export const ServicesGrid = () => {
  const [aml, ai, it, bps, eor, gis, rcm] = SERVICES;

  return (
    <section
      data-testid="services-section"
      className="relative bg-[#040812] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="overline">/02 · Core Enterprise Services</span>
              <h2 className="mt-6 font-display text-white text-4xl md:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.05]">
              Seven practices.
              <br />
              One standard of{" "}
              <span className="text-red-500">discipline</span>.
            </h2>
          </div>
          <p className="text-slate-400 text-base leading-relaxed max-w-md">
            Every engagement is scoped, staffed and shipped by the same senior
            team that built the practice. No hand-offs. No outsourced quality.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-3 gap-4 auto-rows-fr">
          <ServiceCard svc={aml} className="md:col-span-1 md:row-span-2" />
          <ServiceCard svc={ai} className="md:col-span-2 md:row-span-1" />
          <ServiceCard svc={it} className="md:col-span-1 md:row-span-1" />
          <ServiceCard svc={bps} className="md:col-span-1 md:row-span-1" />
          <ServiceCard svc={eor} className="md:col-span-1 md:row-span-1" />
          <ServiceCard svc={gis} className="md:col-span-1 md:row-span-1" />
          <ServiceCard svc={rcm} className="md:col-span-1 md:row-span-1" />
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
